export const initRating = () => {
  const ratingRadios: NodeListOf<HTMLDivElement> = document.querySelectorAll(".rating-radio");

  if (!ratingRadios) {
    return;
  }

  const setLabels = (ratingRadio: HTMLDivElement, value: number) => {
    const unselectedValue = value + 1;
    const selectedLabels = ratingRadio.querySelectorAll(`label:nth-child(-n+${value})`);
    const unselectedLabels = ratingRadio.querySelectorAll(`label:nth-child(n+${unselectedValue})`);

    selectedLabels.forEach((selectedLabel) => {
      const icon = selectedLabel.querySelector(".icon") as HTMLElement;
      const iconActive = selectedLabel.querySelector(".iconActive") as HTMLElement;

      icon.classList.add("d-none");
      iconActive.classList.remove("d-none");
    });

    unselectedLabels.forEach((unselectedLabel) => {
      const icon = unselectedLabel.querySelector(".icon") as HTMLElement;
      const iconActive = unselectedLabel.querySelector(".iconActive") as HTMLElement;

      icon.classList.remove("d-none");
      iconActive.classList.add("d-none");
    });
  };

  const removeReviewValue = (e: MouseEvent) => {
    const currentTarget = e.currentTarget as HTMLDivElement;
    const ratingRadio = currentTarget.closest(".rating-radio") as HTMLDivElement;
    if (!ratingRadio) return;
    const checkedInput = ratingRadio.querySelector("input:checked") as HTMLInputElement;
    let value = 0;

    if (checkedInput) {
      value = parseInt(checkedInput.value, 10);
    }

    setLabels(ratingRadio, value);
  };

  const addReviewValue = (e: MouseEvent | TouchEvent) => {
    const currentTarget = e.currentTarget as HTMLDivElement;
    const ratingRadio = currentTarget.closest(".rating-radio") as HTMLDivElement;

    if (currentTarget.dataset.value) {
      const value = parseInt(currentTarget.dataset.value, 10);
      setLabels(ratingRadio, value);
    }
  };

  ratingRadios.forEach((ratingRadio: HTMLDivElement) => {
    const ratingLabels: NodeListOf<HTMLLabelElement> =
      ratingRadio.querySelectorAll(".labels label");

    ratingLabels.forEach((ratingLabel) => {
      ratingLabel.addEventListener("mouseleave", removeReviewValue);
    });

    ratingLabels.forEach((ratingLabel) => {
      ratingLabel.addEventListener("mouseenter", addReviewValue);
      ratingLabel.addEventListener("touchstart", addReviewValue, {
        passive: true,
      });
      ratingLabel.addEventListener("click", addReviewValue);
    });
  });
};
